import { DatatableCell, Skeleton } from '@monksflow/monks-ui';
import { TableSkeletonActionsCell, TableSkeletonRow } from '@/shared/ui/data-table';

/** Loading placeholder for {@link DeliveryJobGrid}. Column order and widths match the header. */
export const DeliveryJobSkeletonRow = () => (
  <TableSkeletonRow testId="delivery-job-skeleton-row">
    {/* Job — title */}
    <DatatableCell>
      <Skeleton className="h-4 w-56" />
    </DatatableCell>

    {/* Source — the file it came from */}
    <DatatableCell>
      <Skeleton className="h-4 w-40" />
    </DatatableCell>

    {/* Platforms — stacked logos */}
    <DatatableCell>
      <div className="flex items-center gap-1.5">
        <Skeleton className="size-6 rounded-sm" />
        <Skeleton className="size-6 rounded-sm" />
      </div>
    </DatatableCell>

    {/* Contents */}
    <DatatableCell>
      <Skeleton className="h-4 w-28" />
    </DatatableCell>

    {/* Status — rounded-full pill */}
    <DatatableCell>
      <Skeleton className="h-6 w-24 rounded-full" />
    </DatatableCell>

    {/* Created */}
    <DatatableCell>
      <Skeleton className="h-4 w-20" />
    </DatatableCell>

    <TableSkeletonActionsCell />
  </TableSkeletonRow>
);

DeliveryJobSkeletonRow.displayName = 'DeliveryJobSkeletonRow';
